import React from 'react'
import { Typography } from 'antd';

const { Title } = Typography;

const Dashboard = () => {
  return (
    <div>
        <Title level={2} className='coming-soon'>Coming Soon ... </Title>
    </div>
  )
}

export default Dashboard